module.exports = __webpack_public_path__ + "img/78.f33647c0.jpg";